import { useState } from 'react';
import { getUserDataExport, getMediaExport } from '../api/getDataExport';

export default function useDataExport() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMediaModalOpen, setIsMediaModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isMediaLoading, setIsMediaLoading] = useState(false);
    const [blobUrl, setBlobUrl] = useState<string | null>(null);
    const [mediaBlobUrl, setMediaBlobUrl] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [mediaErrorMessage, setMediaErrorMessage] = useState<string | null>(null);

    const exportUserData = async () => {
        setIsLoading(true);
        setErrorMessage(null);
        try {
            const response = await getUserDataExport();

            if (response.error) {
                setIsLoading(false);
                return;
            }

            if (!response.data) {
                setIsLoading(false);
                return;
            }

            setBlobUrl(window.URL.createObjectURL(response.data));
            setIsLoading(false);
            setIsModalOpen(true);
        } catch (error) {
            console.error('Error exporting data:', error);
            setErrorMessage(
                'There was an error exporting your user data.'
            );
            setIsLoading(false);
        }
    };

    const exportMedia = async () => {
        setIsMediaLoading(true);
        setMediaErrorMessage(null);
        try {
            const response = await getMediaExport();

            if (response.error) {
                setIsMediaLoading(false);
                return;
            }

            if (!response.data) {
                setIsMediaLoading(false);
                return;
            }

            setMediaBlobUrl(window.URL.createObjectURL(response.data));
            setIsMediaLoading(false);
            setIsMediaModalOpen(true);
        } catch (error) {
            console.error('Error exporting media:', error);
            setMediaErrorMessage(
                'There was an error exporting your media.'
            );
            setIsMediaLoading(false);
        }
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setIsMediaModalOpen(false);
    };

    const handleDownload = () => {
        if (blobUrl !== null) {
            const dateString = new Date().toISOString().split('T')[0];
            const fileName = `trainheroic-userData-export-${dateString}.zip`;
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            handleClose();
        }
    };

    const handleMediaDownload = () => {
        if (mediaBlobUrl !== null) {
            const dateString = new Date().toISOString().split('T')[0];
            const fileName = `trainheroic-media-export-${dateString}.zip`;
            const link = document.createElement('a');
            link.href = mediaBlobUrl;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            handleClose();
        }
    };

    return {
        exportUserData,
        exportMedia,
        handleClose,
        handleDownload,
        handleMediaDownload,
        isLoading,
        isMediaLoading,
        isModalOpen,
        isMediaModalOpen,
        errorMessage,
        mediaErrorMessage
    };
}
